module.exports = __webpack_public_path__ + "static/media/climact-logo.569b2ea5.png";